import React, { PropTypes } from 'react'
import prefixAll from 'inline-style-prefixer/static'

import Interactable from './utility/Interactable'
import ButtonLink from './ButtonLink'

const getStyles = ({ isHovering }) => ({
  root: prefixAll({
    fontWeight: 'auto',
    borderRadius: 20,
    fontFamily: 'Mono Social Icons Font',
    textRendering: 'optimizeLegibility',
    color: '#DDD',
    backgroundColor: 'transparent',
    border: 'none',
    textDecoration: 'none',
    fontSize: 30,
    padding: 2,
    margin: 0,
    fontSmoothing: 'antialiased'
  })
})

const SocialMediaButton = ({ children, style, ...rest }) => {
  const styles = getStyles(rest)

  return (
    <ButtonLink {...rest} style={styles.root}>
      { children }
    </ButtonLink>
  )
}

SocialMediaButton.propTypes = {
  children: PropTypes.any
}

export default SocialMediaButton



// WEBPACK FOOTER //
// ./src/components/SocialMediaButton.js